import { observer } from "mobx-react";
import React from "react";
import { PermissionFallbackComponent } from "../../components/HOC/withPermissionFallback/permissionFallbackComponent";
import { Report } from "../../components/reports/report";
import { useStore } from "../../models";
import { ReportsScope } from "../../models/reports/ReportsScope";
import { DashboardView } from "../dashboard/views/DashboardView";
import styles from "../settings/settingsEditCommon.css";

export interface Props {
  view: DashboardView;
  scope: ReportsScope;
}

export const ReportsContainer = observer(({ view, scope }: Props) => {
  const { reportsStore, uiStore } = useStore();

  // render all so they won't refresh on report change
  const renderTabs = () => {
    const tabs = reportsStore.allTabs;

    return (
      !!tabs.length &&
      tabs.map((tab) => (
        <Report
          key={tab.scope + tab.dashboardView}
          active={view === tab.dashboardView && tab.scope === scope}
          tab={tab}
        />
      ))
    );
  };

  return uiStore.canDisplayReports(scope) ? (
    <div className={styles["container-scroll"]}>
      <div className={styles.container}>{renderTabs()}</div>
    </div>
  ) : (
    <PermissionFallbackComponent />
  );
});
